<template>
  <div>
    <a-alert type="warning">
      <div slot="message">
        Code is not duplicate / Mã không được trùng với mã hiện có
      </div>
    </a-alert>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
    >
      <a-form-model-item label="Group / Nhóm" prop="groupId">
        <SelectHelpdeskGroup
          v-model="form.groupId"
          :initial-datas="form.group ? [form.group] : null"
          :select-props="{ placeholder: 'Choose group', value: form.groupId }"
        />
      </a-form-model-item>
      <a-form-model-item label="Code / Mã" prop="code">
        <a-input v-model="form.code" placeholder="Enter text" />
      </a-form-model-item>
      <a-form-model-item label="Title / Danh mục" prop="title">
        <a-input v-model="form.title" placeholder="Enter text" />
      </a-form-model-item>
      <a-form-model-item label="Description / Mô tả">
        <VueEditor
          class="ict24h-editor"
          :editor-toolbar="customToolbar"
          placeholder="Enter text"
          v-model="form.description"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="Process users">
        <SelectUser
          :selectProps="{
            placeholder: 'Choose users',
            mode: 'multiple',
            value: form.processUserIds,
          }"
          v-model="form.processUserIds"
          :variablesQuery="{ hasEmployee: undefined }"
        />
      </a-form-model-item> -->
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Add
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
import SelectHelpdeskGroup from "@/components/common/helpdeskGroup/select";

const defaultForm = { processUserIds: undefined };
export default {
  components: { SelectHelpdeskGroup },
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      rules: {
        groupId: [
          {
            required: true,
            message: "Required / Thông tin không được bỏ trống",
          },
        ],
        title: [
          {
            required: true,
            message: "Required / Thông tin không được bỏ trống",
          },
        ],
        code: [
          {
            required: true,
            message: "Required / Thông tin không được bỏ trống",
          },
          {
            validator: (rule, value, callback) => {
              const regCode = /^\w{4,100}$/;
              if (!regCode.test(value)) {
                callback(
                  new Error(
                    "Mã yêu cầu tối thiểu 4 ký tự, không được trùng, không dấu cách, không dấu,ký tự đặc biệt trừ dấu _"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...defaultForm },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedHelpdesk();
        } else {
          return false;
        }
      });
    },
    onCreatedHelpdesk() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createHelpdeskCategory,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Thêm danh mục hỗ trợ thành công!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createHelpdeskCategory?.id) {
            this.refreshAfterCreated(data.createHelpdeskCategory);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Thêm danh mục hỗ trợ không thành công!",
          });
          console.log("Thêm danh mục hỗ trợ không thành công", err);
        });
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
